import React from "react";
export default function ShopTitle() {
  return <section data-section-id="222341" id="shop-title" className="w-full py-20 md:py-32 bg-background text-foreground relative overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
      backgroundImage: `linear-gradient(var(--border) 1px, transparent 1px), linear-gradient(90deg, var(--border) 1px, transparent 1px)`,
      backgroundSize: '40px 40px'
    }} />
      
      <div className="container mx-auto px-4 md:px-6 flex flex-col items-center text-center relative z-10">
        <h1 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold tracking-tighter text-primary mb-6">
          Marine Spare Parts Catalog
        </h1>
        <p className="font-sans text-lg md:text-xl text-muted-foreground max-w-2xl mb-8">
          Premium Japanese OEM quality components engineered for ultimate reliability and performance.
        </p>
        
        {}
        <nav className="flex items-center space-x-2 text-sm font-mono uppercase tracking-widest text-secondary">
          <span className="hover:text-primary transition-colors cursor-pointer">Home</span>
          <span className="text-border">/</span>
          <span className="text-primary font-semibold">Products</span>
        </nav>
      </div>
    </section>;
}